const PALETTE = ["#0A7CFF", "#F97316", "#10b981", "#8b5cf6", "#ef4444", "#0ea5e9", "#eab308"];

const hue = (s = "") => { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return PALETTE[h % PALETTE.length]; };
const initial = (p) => (p?.name || p?.email || "?").trim()[0]?.toUpperCase() || "?";
const label = (p) => p?.name || p?.email || "Alguém";

// Overlapping avatar stack of people currently editing. `live` adds a green pulse ring.
export const Avatars = ({ people = [], size = 26, live = false, max = 4, testid }) => {
  if (!people.length) return null;
  const shown = people.slice(0, max);
  const extra = people.length - shown.length;
  return (
    <div data-testid={testid} className="flex items-center" title={people.map(label).join(", ") + (live ? " · editando agora" : "")}>
      <div className="flex -space-x-2">
        {shown.map((p, i) => (
          <span key={p.user_id || i} className={`relative grid place-items-center rounded-full text-white font-bold ring-2 ring-white ${live ? "shadow-[0_0_0_2px_rgba(16,185,129,0.5)]" : ""}`}
            style={{ width: size, height: size, fontSize: size * 0.42, background: hue(p.email || p.name), zIndex: shown.length - i }}>
            {p.picture ? <img src={p.picture} alt="" className="w-full h-full rounded-full object-cover" /> : initial(p)}
          </span>
        ))}
        {extra > 0 && (
          <span className="grid place-items-center rounded-full bg-slate-200 text-slate-600 font-semibold ring-2 ring-white" style={{ width: size, height: size, fontSize: size * 0.38 }}>+{extra}</span>
        )}
      </div>
      {live && <span className="ml-2 hidden sm:flex items-center gap-1.5 text-[11px] font-medium text-emerald-600"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" /> editando agora</span>}
    </div>
  );
};

export { hue as avatarColor, initial as avatarInitial, label as avatarLabel };
